(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6865],{

/***/ 3909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _src_components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52738);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var LastUpdate = function LastUpdate(_ref) {
  var isMobileVersion = _ref.isMobileVersion,
      updatedAt = _ref.updatedAt,
      isGuide = _ref.isGuide;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    style: {
      marginTop: 15,
      display: "flex",
      flexDirection: "row",
      alignSelf: "stretch",
      alignItems: "center",
      marginLeft: isGuide ? 15 : 0
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      style: {
        width: isMobileVersion ? 20 : 22,
        height: isMobileVersion ? 20 : 22,
        backgroundColor: (0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-icon-gray1"),
        borderRadius: 100,
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        marginLeft: 2
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .CImage */ .DW, {
        source: _src_config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconCalendarWhite */ .rU.iconCalendarWhite,
        layout: "fixed",
        width: isMobileVersion ? 10 : 12,
        height: isMobileVersion ? 10 : 12
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      style: {
        fontSize: isMobileVersion ? 9 : 12,
        fontFamily: _src_config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular,
        color: (0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-darkGray"),
        marginLeft: "10px",
        textAlign: "left"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("time", {
        dateTime: updatedAt,
        pubDate: true,
        children: ["Last updated on ", moment__WEBPACK_IMPORTED_MODULE_3___default()(updatedAt).format("DD/MM/YYYY")]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LastUpdate);

/***/ }),

/***/ 20661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slugs_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components_web/guides/component/GuideContinent.js
var component_GuideContinent = __webpack_require__(46497);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var es_useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./components_web/Header.js
var components_web_Header = __webpack_require__(67099);
// EXTERNAL MODULE: ./components_web/Footer.js
var components_web_Footer = __webpack_require__(52460);
// EXTERNAL MODULE: ./components_web/SideMenu.js
var components_web_SideMenu = __webpack_require__(92063);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify_slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify_slugify);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components_web/guides/component/GuideCountry.js

















var GuideCountry_GuideCountry = function GuideCountry(props) {
  var _uniqBy, _uniqBy$sort, _states$sort, _uniqBy2, _uniqBy2$sort, _states$sort2, _uniqBy3, _uniqBy3$sort;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var categoryType = props.categoryType,
      listDataCountry = props.listDataCountry,
      listDataState = props.listDataState,
      listDataCity = props.listDataCity,
      listData = props.listData,
      listDataFilter = props.listDataFilter,
      continentSelected = props.continentSelected,
      countrySelected = props.countrySelected;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var countries = listDataCountry;
  var states = listDataState;
  var cities = listData;
  var types = listDataFilter;
  var countryData = countries === null || countries === void 0 ? void 0 : countries.find(function (i) {
    var _i$countryName;

    return slugify_default()((_i$countryName = i.countryName) === null || _i$countryName === void 0 ? void 0 : _i$countryName.toLowerCase()) === countrySelected;
  });
  var metaTitle = (countrySelected === null || countrySelected === void 0 ? void 0 : countrySelected.toLowerCase()) === "world" ? "World" : "".concat(countryData === null || countryData === void 0 ? void 0 : countryData.countryName);
  var metaDescription = "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0).concat((countrySelected === null || countrySelected === void 0 ? void 0 : countrySelected.toLowerCase()) === "world" ? " around the World" : " in ".concat(countryData === null || countryData === void 0 ? void 0 : countryData.countryName), " with our guides.");
  (0,react.useEffect)(function () {
    setIsMobileVersion(config/* Values.deviceWidth */.$m.deviceWidth < 640);
  }, [config/* Values.deviceWidth */.$m.deviceWidth]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex: false,
      nofollow: false,
      title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: "https://".concat("www.cocktayl.co", "/guides/").concat(continentSelected, "/").concat(countrySelected),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.cocktayl.co", "/guides/").concat(continentSelected, "/").concat(countrySelected),
        title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Header/* default */.Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_SideMenu/* default */.Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((0,formatHelpers/* getClass */.ll)("background", true)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* NavigationBar */.vx, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? router.push("/guides") : router.push("/guides/".concat(continentSelected));
            }
          }), categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [(countrySelected === null || countrySelected === void 0 ? void 0 : countrySelected.toLowerCase()) !== "world" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-row items-center justify-center mb-[30px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center ".concat((0,formatHelpers/* getClass */.ll)("btn-gradient", true), " rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]"),
                children: "Country"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-row flex-wrap items-center px-[20px]",
              children: (_uniqBy = (0,lodash.uniqBy)(types, "filterId")) === null || _uniqBy === void 0 ? void 0 : (_uniqBy$sort = _uniqBy.sort(function (a, b) {
                return (a === null || a === void 0 ? void 0 : a.filterOrder) - (b === null || b === void 0 ? void 0 : b.filterOrder);
              })) === null || _uniqBy$sort === void 0 ? void 0 : _uniqBy$sort.map(function (item, index) {
                var _item$filterName, _item$filterName$repl, _item$filterName2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/guides/".concat(countrySelected, "/").concat((item === null || item === void 0 ? void 0 : item.filterName) === "All" ?  false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0 : ((item === null || item === void 0 ? void 0 : item.filterName) !== "Pool" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Bar" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Restaurant" ? slugify_default()(item === null || item === void 0 ? void 0 : (_item$filterName = item.filterName) === null || _item$filterName === void 0 ? void 0 : (_item$filterName$repl = _item$filterName.replace("Aviary", "Aviaries")) === null || _item$filterName$repl === void 0 ? void 0 : _item$filterName$repl.toLowerCase()) + "-" : "") + "".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0).concat(item && ((item === null || item === void 0 ? void 0 : item.filterName) === "Pool" || (item === null || item === void 0 ? void 0 : item.filterName) === "Bar" || (item === null || item === void 0 ? void 0 : item.filterName) === "Restaurant") ? "-" + slugify_default()((item === null || item === void 0 ? void 0 : (_item$filterName2 = item.filterName) === null || _item$filterName2 === void 0 ? void 0 : _item$filterName2.toLowerCase()) + "s") : "")),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "flex flex-col justify-center items-center border ".concat((0,formatHelpers/* getClass */.ll)("border-black", true), " px-[10px] py-[5px] rounded-full ").concat((0,formatHelpers/* getClass */.ll)("text-white", true), " uppercase font-regular text-base text-center ").concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: item === null || item === void 0 ? void 0 : item.filterName
                    })
                  }, index)
                });
              })
            }), states.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-row items-center justify-center mb-[30px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center ".concat((0,formatHelpers/* getClass */.ll)("btn-gradient", true), " rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]"),
                children: "State"
              })
            }), states.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-row flex-wrap items-center px-[20px]",
              children: states === null || states === void 0 ? void 0 : (_states$sort = states.sort(function (a, b) {
                if (a.stateName < b.stateName) {
                  return -1;
                }

                if (a.stateName > b.stateName) {
                  return 1;
                }

                return 0;
              })) === null || _states$sort === void 0 ? void 0 : _states$sort.map(function (item, index) {
                var _item$stateName;

                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/guides/".concat(countrySelected, "/").concat(slugify_default()(item === null || item === void 0 ? void 0 : (_item$stateName = item.stateName) === null || _item$stateName === void 0 ? void 0 : _item$stateName.toLowerCase()), "-state"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "flex flex-col justify-center items-center border ".concat((0,formatHelpers/* getClass */.ll)("border-black", true), " px-[10px] py-[5px] rounded-full ").concat((0,formatHelpers/* getClass */.ll)("text-white", true), " uppercase font-regular text-base text-center ").concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: item === null || item === void 0 ? void 0 : item.stateName
                    })
                  }, index)
                });
              })
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [( false) && /*#__PURE__*/0, ( false) && /*#__PURE__*/0, states.filter(function (item) {
              return  false ? 0 :  false ? 0 : true;
            }).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-row items-center justify-center mb-[30px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center ".concat((0,formatHelpers/* getClass */.ll)("btn-gradient", true), " rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]"),
                children: "State"
              })
            }), ( false) && /*#__PURE__*/0, ( false) && /*#__PURE__*/0, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-row flex-wrap items-center px-[20px]",
              children: (_uniqBy3 = (0,lodash.uniqBy)(cities.filter(function (item) {
                return  false ? 0 :  false ? 0 : true;
              }), "cityName")) === null || _uniqBy3 === void 0 ? void 0 : (_uniqBy3$sort = _uniqBy3.sort(function (a, b) {
                if (a.cityName < b.cityName) {
                  return -1;
                }

                if (a.cityName > b.cityName) {
                  return 1;
                }

                return 0;
              })) === null || _uniqBy3$sort === void 0 ? void 0 : _uniqBy3$sort.map(function (item, index) {
                var _item$cityName;

                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/guides/".concat(continentSelected, "/").concat(countrySelected, "/").concat(slugify_default()(item === null || item === void 0 ? void 0 : (_item$cityName = item.cityName) === null || _item$cityName === void 0 ? void 0 : _item$cityName.toLowerCase())).concat( false ? 0 : "").concat( false ? 0 : ""),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "flex flex-col justify-center items-center border ".concat((0,formatHelpers/* getClass */.ll)("border-black", true), " px-[10px] py-[5px] rounded-full ").concat((0,formatHelpers/* getClass */.ll)("text-white", true), " uppercase font-regular text-base text-center ").concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: item === null || item === void 0 ? void 0 : item.cityName
                    })
                  }, index)
                });
              })
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var component_GuideCountry = (GuideCountry_GuideCountry);
;// CONCATENATED MODULE: ./components_web/guides/component/GuideCity.js
















var GuideCity_GuideCity = function GuideCity(props) {
  var _uniqBy, _uniqBy$sort;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var listDataCity = props.listDataCity,
      listData = props.listData,
      continentSelected = props.continentSelected,
      countrySelected = props.countrySelected,
      stateSelected = props.stateSelected,
      citySelected = props.citySelected;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var cities = listDataCity;
  var types = listData;
  var cityData = cities === null || cities === void 0 ? void 0 : cities.find(function (i) {
    var _i$cityName;

    return slugify_default()((_i$cityName = i.cityName) === null || _i$cityName === void 0 ? void 0 : _i$cityName.toLowerCase()) === ( false ? 0 : citySelected);
  });
  var metaTitle = "".concat(cityData === null || cityData === void 0 ? void 0 : cityData.cityName);
  var metaDescription = "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " in ").concat(cityData === null || cityData === void 0 ? void 0 : cityData.cityName, " with our guides.");
  (0,react.useEffect)(function () {
    setIsMobileVersion(config/* Values.deviceWidth */.$m.deviceWidth < 640);
  }, [config/* Values.deviceWidth */.$m.deviceWidth]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex: false,
      nofollow: false,
      title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: "https://".concat("www.cocktayl.co", "/guides/").concat(continentSelected, "/").concat(countrySelected, "/").concat(citySelected),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.cocktayl.co", "/guides/").concat(continentSelected, "/").concat(countrySelected, "/").concat(citySelected),
        title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Header/* default */.Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_SideMenu/* default */.Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((0,formatHelpers/* getClass */.ll)("background", true)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* NavigationBar */.vx, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides/".concat(continentSelected, "/").concat(countrySelected));
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-row flex-wrap items-center px-[20px]",
            children: (_uniqBy = (0,lodash.uniqBy)(types, "filterId")) === null || _uniqBy === void 0 ? void 0 : (_uniqBy$sort = _uniqBy.sort(function (a, b) {
              return (a === null || a === void 0 ? void 0 : a.filterOrder) - (b === null || b === void 0 ? void 0 : b.filterOrder);
            })) === null || _uniqBy$sort === void 0 ? void 0 : _uniqBy$sort.map(function (item, index) {
              var _item$filterName, _item$filterName2, _item$filterName2$rep, _item$filterName2$rep2, _item$filterName3, _item$filterName3$rep;

              return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/guides/".concat(continentSelected, "/").concat(countrySelected, "/").concat(citySelected, "/").concat((item === null || item === void 0 ? void 0 : item.filterName) === "All" ?  false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0 : ( false ? 0 : (item === null || item === void 0 ? void 0 : item.filterName) !== "Pool" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Bar" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Restaurant" ? slugify_default()(item === null || item === void 0 ? void 0 : (_item$filterName3 = item.filterName) === null || _item$filterName3 === void 0 ? void 0 : (_item$filterName3$rep = _item$filterName3.replace(" Spa", "")) === null || _item$filterName3$rep === void 0 ? void 0 : _item$filterName3$rep.toLowerCase()) + "-" : "") + "".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0).concat(item && ((item === null || item === void 0 ? void 0 : item.filterName) === "Pool" || (item === null || item === void 0 ? void 0 : item.filterName) === "Bar" || (item === null || item === void 0 ? void 0 : item.filterName) === "Restaurant") ? "-" + slugify_default()((item === null || item === void 0 ? void 0 : item.filterName.toLowerCase()) + "s") : "")),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "flex flex-col justify-center items-center border ".concat((0,formatHelpers/* getClass */.ll)("border-black", true), " px-[10px] py-[5px] rounded-full ").concat((0,formatHelpers/* getClass */.ll)("text-white", true), " uppercase font-regular text-base text-center ").concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: item === null || item === void 0 ? void 0 : item.filterName
                  })
                }, index)
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var component_GuideCity = (GuideCity_GuideCity);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components_web/LastUpdate.js
var components_web_LastUpdate = __webpack_require__(3909);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/DAO/index.js + 12 modules
var DAO = __webpack_require__(90793);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ActivityIndicator/index.js
var exports_ActivityIndicator = __webpack_require__(89009);
var ActivityIndicator_default = /*#__PURE__*/__webpack_require__.n(exports_ActivityIndicator);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var exports_Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(exports_Text);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var exports_TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(exports_TouchableOpacity);
;// CONCATENATED MODULE: ./components_web/guides/component/GuideType.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var GuideType_GuideType = function GuideType(props) {
  var _typeData$filterName, _typeData$filterName$, _typeData$filterName$2, _typeData$filterName$3, _typeData$filterName$4, _typeData$filterName$5, _typeData$filterName$6, _typeData$filterName$7, _typeData$filterName2, _typeData$filterName3, _typeData$filterName4, _typeData$filterName5, _typeData$filterName6, _typeData$filterName7, _typeData$filterName8, _typeData$filterName9, _typeData$filterName10, _typeData$filterName11, _typeData$filterName12, _typeData$filterName13, _typeData$filterName14, _typeData$filterName15, _typeData$filterName16, _typeData$filterName17, _typeData$filterName18, _typeData$filterName19, _typeData$filterName20, _typeData$filterName21, _typeData$filterName22;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var categoryType = props.categoryType,
      listDataCountry = props.listDataCountry,
      listDataState = props.listDataState,
      listDataCity = props.listDataCity,
      listDataFilter = props.listDataFilter,
      listData = props.listData,
      countListData = props.countListData,
      continentSelected = props.continentSelected,
      countrySelected = props.countrySelected,
      citySelected = props.citySelected,
      typeSelected = props.typeSelected,
      stateSelected = props.stateSelected,
      paramsFinal = props.paramsFinal;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      items = _useState4[0],
      setItems = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      totalCount = _useState5[0],
      setTotalCount = _useState5[1];

  var _useState6 = (0,react.useState)(0),
      lastPageCount = _useState6[0],
      setLastPageCount = _useState6[1];

  var _useState7 = (0,react.useState)(0),
      pageIndex = _useState7[0],
      setPageIndex = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var isShowLoadMore = items.length < totalCount;
  var countries = listDataCountry;
  var states = listDataState;
  var cities = listDataCity;
  var types = listDataFilter;
  var countryData = countries === null || countries === void 0 ? void 0 : countries.find(function (i) {
    var _i$countryName;

    return slugify_default()((_i$countryName = i.countryName) === null || _i$countryName === void 0 ? void 0 : _i$countryName.toLowerCase()) === countrySelected;
  });
  var cityData = cities === null || cities === void 0 ? void 0 : cities.find(function (i) {
    var _i$cityName;

    return slugify_default()((_i$cityName = i.cityName) === null || _i$cityName === void 0 ? void 0 : _i$cityName.toLowerCase()) === ( false ? 0 : citySelected);
  });
  var stateData = states === null || states === void 0 ? void 0 : states.find(function (i) {
    var _i$stateName;

    return slugify_default()((_i$stateName = i.stateName) === null || _i$stateName === void 0 ? void 0 : _i$stateName.toLowerCase()) === (stateSelected === null || stateSelected === void 0 ? void 0 : stateSelected.replace("-state", ""));
  });
  var typeData = types === null || types === void 0 ? void 0 : types.find(function (i) {
    var _i$filterName, _typeSelected$replace, _typeSelected$replace2, _typeSelected$replace3, _typeSelected$replace4, _typeSelected$replace5, _typeSelected$replace6, _typeSelected$replace7, _typeSelected$replace8, _typeSelected$replace9, _typeSelected$replace10, _typeSelected$replace11, _typeSelected$replace12, _typeSelected$replace13, _typeSelected$replace14, _typeSelected$replace15, _typeSelected$replace16, _typeSelected$replace17, _typeSelected$replace18, _typeSelected$replace19, _typeSelected$replace20, _typeSelected$replace21, _typeSelected$replace22, _typeSelected$replace23, _typeSelected$replace24, _typeSelected$replace25, _typeSelected$replace26, _typeSelected$replace27, _typeSelected$replace28;

    return slugify_default()(i === null || i === void 0 ? void 0 : (_i$filterName = i.filterName) === null || _i$filterName === void 0 ? void 0 : _i$filterName.toLowerCase()) === (typeSelected === null || typeSelected === void 0 ? void 0 : (_typeSelected$replace = typeSelected.replace("-".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0), "") // RooftopClub
    ) === null || _typeSelected$replace === void 0 ? void 0 : (_typeSelected$replace2 = _typeSelected$replace.replace("rooftop-", "")) === null || _typeSelected$replace2 === void 0 ? void 0 : (_typeSelected$replace3 = _typeSelected$replace2.replace("bars", "bar")) === null || _typeSelected$replace3 === void 0 ? void 0 : (_typeSelected$replace4 = _typeSelected$replace3.replace("restaurants", "restaurant")) === null || _typeSelected$replace4 === void 0 ? void 0 : (_typeSelected$replace5 = _typeSelected$replace4.replace("pools", "pool") // SpaClub
    ) === null || _typeSelected$replace5 === void 0 ? void 0 : (_typeSelected$replace6 = _typeSelected$replace5.replace("day", "day-spa")) === null || _typeSelected$replace6 === void 0 ? void 0 : (_typeSelected$replace7 = _typeSelected$replace6.replace("destination", "destination-spa")) === null || _typeSelected$replace7 === void 0 ? void 0 : (_typeSelected$replace8 = _typeSelected$replace7.replace("thermal", "thermal-spa")) === null || _typeSelected$replace8 === void 0 ? void 0 : (_typeSelected$replace9 = _typeSelected$replace8.replace("hotel", "hotel-spa")) === null || _typeSelected$replace9 === void 0 ? void 0 : (_typeSelected$replace10 = _typeSelected$replace9.replace("club", "club-spa")) === null || _typeSelected$replace10 === void 0 ? void 0 : (_typeSelected$replace11 = _typeSelected$replace10.replace("medical", "medical-spa") // Zoopedia
    ) === null || _typeSelected$replace11 === void 0 ? void 0 : (_typeSelected$replace12 = _typeSelected$replace11.replace("zoos", "zoo")) === null || _typeSelected$replace12 === void 0 ? void 0 : (_typeSelected$replace13 = _typeSelected$replace12.replace("wildlife-parks", "wildlife-park")) === null || _typeSelected$replace13 === void 0 ? void 0 : (_typeSelected$replace14 = _typeSelected$replace13.replace("animal-sanctuaries", "animal-sanctuary")) === null || _typeSelected$replace14 === void 0 ? void 0 : (_typeSelected$replace15 = _typeSelected$replace14.replace("aquariums", "aquarium")) === null || _typeSelected$replace15 === void 0 ? void 0 : (_typeSelected$replace16 = _typeSelected$replace15.replace("marine-mammal-parks", "marine-mammal-park")) === null || _typeSelected$replace16 === void 0 ? void 0 : (_typeSelected$replace17 = _typeSelected$replace16.replace("penguinariums", "penguinarium")) === null || _typeSelected$replace17 === void 0 ? void 0 : (_typeSelected$replace18 = _typeSelected$replace17.replace("dolphinariums", "dolphinarium")) === null || _typeSelected$replace18 === void 0 ? void 0 : (_typeSelected$replace19 = _typeSelected$replace18.replace("aviaries", "aviary")) === null || _typeSelected$replace19 === void 0 ? void 0 : (_typeSelected$replace20 = _typeSelected$replace19.replace("nocturnal-houses", "nocturnal-house")) === null || _typeSelected$replace20 === void 0 ? void 0 : (_typeSelected$replace21 = _typeSelected$replace20.replace("petting-zoos", "petting-zoo")) === null || _typeSelected$replace21 === void 0 ? void 0 : (_typeSelected$replace22 = _typeSelected$replace21.replace("animal-theme-parks", "animal-theme-park")) === null || _typeSelected$replace22 === void 0 ? void 0 : (_typeSelected$replace23 = _typeSelected$replace22.replace("reptilariums", "reptilarium")) === null || _typeSelected$replace23 === void 0 ? void 0 : (_typeSelected$replace24 = _typeSelected$replace23.replace("herpetariums", "herpetarium")) === null || _typeSelected$replace24 === void 0 ? void 0 : (_typeSelected$replace25 = _typeSelected$replace24.replace("serpentariums", "serpentarium")) === null || _typeSelected$replace25 === void 0 ? void 0 : (_typeSelected$replace26 = _typeSelected$replace25.replace("farms", "farm")) === null || _typeSelected$replace26 === void 0 ? void 0 : (_typeSelected$replace27 = _typeSelected$replace26.replace("oceanariums", "oceanarium") // Parkful
    ) === null || _typeSelected$replace27 === void 0 ? void 0 : (_typeSelected$replace28 = _typeSelected$replace27.replace("theme-parks", "theme-park")) === null || _typeSelected$replace28 === void 0 ? void 0 : _typeSelected$replace28.replace("waterparks", "waterpark"));
  });
  var metaTitle = "".concat((categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" ? "" : typeData && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Pool" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Bar" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Restaurant" ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName = typeData.filterName) === null || _typeData$filterName === void 0 ? void 0 : (_typeData$filterName$ = _typeData$filterName.replace("All", "")) === null || _typeData$filterName$ === void 0 ? void 0 : (_typeData$filterName$2 = _typeData$filterName$.replace("Day Spa", "Day")) === null || _typeData$filterName$2 === void 0 ? void 0 : (_typeData$filterName$3 = _typeData$filterName$2.replace("Destination Spa", "Destination")) === null || _typeData$filterName$3 === void 0 ? void 0 : (_typeData$filterName$4 = _typeData$filterName$3.replace("Thermal Spa", "Thermal")) === null || _typeData$filterName$4 === void 0 ? void 0 : (_typeData$filterName$5 = _typeData$filterName$4.replace("Hotel Spa", "Hotel")) === null || _typeData$filterName$5 === void 0 ? void 0 : (_typeData$filterName$6 = _typeData$filterName$5.replace("Club Spa", "Club")) === null || _typeData$filterName$6 === void 0 ? void 0 : (_typeData$filterName$7 = _typeData$filterName$6.replace("Medical Spa", "Medical")) === null || _typeData$filterName$7 === void 0 ? void 0 : _typeData$filterName$7.replace("Aviary", "Aviaries")) + " " : "").concat( false ? 0 :  false ? 0 :  true ? "Cocktail Bars" : 0, " ").concat((categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "All" ? (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "All" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Aviary" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Animal sanctuary" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Basic" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Premium" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Luxury" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" ? (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) + "s " : (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName2 = typeData.filterName) === null || _typeData$filterName2 === void 0 ? void 0 : (_typeData$filterName3 = _typeData$filterName2.replace("Aviary", "Aviaries")) === null || _typeData$filterName3 === void 0 ? void 0 : _typeData$filterName3.replace("Animal sanctuary", "Animal sanctuaries")) + " " : typeData && ((typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Pool" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Bar" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Restaurant") ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName4 = typeData.filterName) === null || _typeData$filterName4 === void 0 ? void 0 : (_typeData$filterName5 = _typeData$filterName4.replace("All", "")) === null || _typeData$filterName5 === void 0 ? void 0 : _typeData$filterName5.toLowerCase()) + "s " : "").concat((cityData === null || cityData === void 0 ? void 0 : cityData.cityName) || (stateData === null || stateData === void 0 ? void 0 : stateData.stateName) || (countryData === null || countryData === void 0 ? void 0 : countryData.countryName) || "").concat((categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || categoryType === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) && continentSelected === "world" || categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && countrySelected === "world" ? "World" : "");
  var metaDescription = "Discover all the ".concat(categoryType === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? "luxury " : "").concat((categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" ? "" : typeData && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Pool" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Bar" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Restaurant" ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName6 = typeData.filterName) === null || _typeData$filterName6 === void 0 ? void 0 : (_typeData$filterName7 = _typeData$filterName6.replace("All", "")) === null || _typeData$filterName7 === void 0 ? void 0 : (_typeData$filterName8 = _typeData$filterName7.replace("Day Spa", "Day")) === null || _typeData$filterName8 === void 0 ? void 0 : (_typeData$filterName9 = _typeData$filterName8.replace("Destination Spa", "Destination")) === null || _typeData$filterName9 === void 0 ? void 0 : (_typeData$filterName10 = _typeData$filterName9.replace("Thermal Spa", "Thermal")) === null || _typeData$filterName10 === void 0 ? void 0 : (_typeData$filterName11 = _typeData$filterName10.replace("Hotel Spa", "Hotel")) === null || _typeData$filterName11 === void 0 ? void 0 : (_typeData$filterName12 = _typeData$filterName11.replace("Club Spa", "Club")) === null || _typeData$filterName12 === void 0 ? void 0 : (_typeData$filterName13 = _typeData$filterName12.replace("Medical Spa", "Medical")) === null || _typeData$filterName13 === void 0 ? void 0 : (_typeData$filterName14 = _typeData$filterName13.replace("Aviary", "Aviaries")) === null || _typeData$filterName14 === void 0 ? void 0 : _typeData$filterName14.toLowerCase()) + " " : "").concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " ").concat((categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "All" ? (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "All" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Aviary" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Animal sanctuary" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Basic" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Premium" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Luxury" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName15 = typeData.filterName) === null || _typeData$filterName15 === void 0 ? void 0 : _typeData$filterName15.toLowerCase()) + "s " : (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName16 = typeData.filterName) === null || _typeData$filterName16 === void 0 ? void 0 : (_typeData$filterName17 = _typeData$filterName16.replace("Aviary", "Aviaries")) === null || _typeData$filterName17 === void 0 ? void 0 : (_typeData$filterName18 = _typeData$filterName17.replace("Animal sanctuary", "Animal sanctuaries")) === null || _typeData$filterName18 === void 0 ? void 0 : _typeData$filterName18.toLowerCase()) + " " : typeData && ((typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Pool" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Bar" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Restaurant") ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName19 = typeData.filterName) === null || _typeData$filterName19 === void 0 ? void 0 : (_typeData$filterName20 = _typeData$filterName19.replace("All", "")) === null || _typeData$filterName20 === void 0 ? void 0 : _typeData$filterName20.toLowerCase()) + "s " : "").concat((categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) && continentSelected === "world" || categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && countrySelected === "world" ? "around the world " : "in " + ((cityData === null || cityData === void 0 ? void 0 : cityData.cityName) || (stateData === null || stateData === void 0 ? void 0 : stateData.stateName) || (countryData === null || countryData === void 0 ? void 0 : countryData.countryName) || "") + " ", "with our guide.");
  var updatedAt = moment_default()().startOf("week").add("2", "days").toISOString();
  var canonicalURL = "https://".concat("www.cocktayl.co", "/guides").concat(continentSelected ? "/".concat(continentSelected) : "").concat(countrySelected ? "/".concat(countrySelected) : "").concat(stateSelected ? "/".concat(stateSelected) : "").concat(citySelected ? "/".concat(citySelected) : "").concat(typeSelected ? "/".concat(typeSelected) : "");
  (0,react.useEffect)(function () {
    setIsMobileVersion(config/* Values.deviceWidth */.$m.deviceWidth < 640);
  }, [config/* Values.deviceWidth */.$m.deviceWidth]);

  var onLoad = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var page,
          _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;

              if (!isLoading) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setIsLoading(true);
              DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, paramsFinal), {}, {
                pageSize: 100,
                pageIndex: page
              })).then(function (result) {
                if (page == 0) {
                  setItems(result.data);
                } else {
                  setItems([].concat((0,toConsumableArray/* default */.Z)(items), (0,toConsumableArray/* default */.Z)(result.data)));
                }

                setLastPageCount(result.data.length);
                setTotalCount(result.totalCount);
                setIsLoading(false);
              })["catch"](function (error) {
                setIsLoading(false);
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onLoad() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    onLoad();
  }, []);

  var onLoadMore = function onLoadMore() {
    if (lastPageCount == 100 && !isLoading) {
      setPageIndex(pageIndex + 1);
      onLoad(pageIndex + 1);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": canonicalURL,
            url: canonicalURL,
            name: metaTitle,
            dateModified: updatedAt
          })
        }
      }, "structured-data")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex:  false ||  false && (0),
      nofollow:  false ||  false && (0),
      title: "".concat(metaTitle, " - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: canonicalURL,
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: canonicalURL,
        title: "".concat(metaTitle, " - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Header/* default */.Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_SideMenu/* default */.Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((0,formatHelpers/* getClass */.ll)("background", true)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* NavigationBar */.vx, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides".concat(continentSelected ? "/".concat(continentSelected) : "").concat(countrySelected ? "/".concat(countrySelected) : "").concat(stateSelected && "Cocktayl" !== "PrefabWorld" && "Cocktayl" !== "Castlepedia" && "Cocktayl" !== "LuxResort Club" && "Cocktayl" !== "AparthotelClub" ? "/".concat(stateSelected) : "").concat(citySelected && "Cocktayl" !== "Castlepedia" && "Cocktayl" !== "LuxResort Club" && "Cocktayl" !== "AparthotelClub" ? "/".concat(citySelected) : ""));
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-row justify-center items-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-col justify-center items-center border ".concat((0,formatHelpers/* getClass */.ll)("border-black", true), " px-[10px] py-[5px] rounded-full ").concat((0,formatHelpers/* getClass */.ll)("text-white", true), " font-regular sm:text-base text-xs text-center mb-[30px]"),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "".concat((0,formatHelpers/* getClass */.ll)("text-gray2")),
                  children: countListData
                }), "\xA0", categoryType === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? "Clubs" : categoryType === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bars" : categoryType === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? "Rooftops" : categoryType === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? "Spas" : categoryType === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Clubs" : categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Companies" : categoryType === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? "Casinos" : categoryType === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? "Castles" : categoryType === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? "Resorts" : categoryType === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? "Aparthotels" : categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "All" ? (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "All" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Aviary" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Animal sanctuary" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Basic" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Premium" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Luxury" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Best" ? (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) + "s " : (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName21 = typeData.filterName) === null || _typeData$filterName21 === void 0 ? void 0 : (_typeData$filterName22 = _typeData$filterName21.replace("Aviary", "Aviaries")) === null || _typeData$filterName22 === void 0 ? void 0 : _typeData$filterName22.replace("Animal sanctuary", "Animal sanctuaries")) + " " : categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "Amusement Parks" : "Zoos & animal parks" : "Venues"]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
              isChartsMode: false,
              isGuides: true,
              horizontal: false,
              gridView: false,
              items: items.length > 0 ? items : listData,
              category: categoryType,
              style: {
                marginTop: 16
              } // onItemAction={({ type, item }) => onItemAction({ type, item })}
              ,
              isLoadingNextPage: false,
              isLoading: false,
              isExploreSearch: true,
              isMobileVersion: isMobileVersion,
              gapHeight: 0
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-center",
            children: [isShowLoadMore && !isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
              style: isMobileVersion ? styles.mobileLoadMoreButtonContainer : styles.loadMoreButtonContainer,
              onPress: onLoadMore,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: [styles.buttonText, isMobileVersion && {
                  fontSize: 12,
                  lineHeight: 12
                }],
                children: "VIEW MORE"
              })
            }), isShowLoadMore && isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-[20px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {})
            })]
          }), listData.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_LastUpdate/* default */.Z, {
            isMobileVersion: isMobileVersion,
            updatedAt: updatedAt,
            isGuide: true
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Footer/* default */.Z, {})]
  });
};

var styles = StyleSheet_default().create({
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: (0,formatHelpers/* getClass */.ll)("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: (0,formatHelpers/* getClass */.ll)("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  buttonText: {
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    textAlign: "center"
  }
});
/* harmony default export */ var component_GuideType = (GuideType_GuideType);
;// CONCATENATED MODULE: ./components_web/guides/GuideRooftop.js


function GuideRooftop_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideRooftop_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideRooftop_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideRooftop_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var GuideRooftop = function GuideRooftop(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideRooftop_objectSpread(GuideRooftop_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideCountry, GuideRooftop_objectSpread(GuideRooftop_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    return /*#__PURE__*/_jsx(GuideCity, GuideRooftop_objectSpread(GuideRooftop_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      citySelected: slugs[2]
    }));
  } else if (slugs.length === 4) {
    return /*#__PURE__*/_jsx(GuideType, GuideRooftop_objectSpread(GuideRooftop_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      citySelected: slugs[2],
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideRooftop = ((/* unused pure expression or super */ null && (GuideRooftop)));
;// CONCATENATED MODULE: ./components_web/guides/component/GuideState.js
















var GuideState_GuideState = function GuideState(props) {
  var _uniqBy, _uniqBy$sort;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var categoryType = props.categoryType,
      listDataCountry = props.listDataCountry,
      listDataState = props.listDataState,
      listDataCity = props.listDataCity,
      listData = props.listData,
      continentSelected = props.continentSelected,
      countrySelected = props.countrySelected,
      stateSelected = props.stateSelected;
  var router = useRouter();

  var _useState = useState(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = useState(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = useState(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var countries = listDataCountry;
  var states = listDataState;
  var cities = listDataCity;
  var types = listData;
  var stateData = states === null || states === void 0 ? void 0 : states.find(function (i) {
    var _i$stateName;

    return slugify((_i$stateName = i.stateName) === null || _i$stateName === void 0 ? void 0 : _i$stateName.toLowerCase()) === (stateSelected === null || stateSelected === void 0 ? void 0 : stateSelected.replace("-state", ""));
  });
  var metaTitle = "".concat(stateData === null || stateData === void 0 ? void 0 : stateData.stateName);
  var metaDescription = "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " in ").concat(stateData === null || stateData === void 0 ? void 0 : stateData.stateName, " with our guides.");
  useEffect(function () {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(NextSeo, {
      noindex: false,
      nofollow: false,
      title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: "https://".concat("www.cocktayl.co", "/guides/").concat(continentSelected, "/").concat(countrySelected, "/").concat(stateSelected),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.cocktayl.co", "/guides/").concat(continentSelected, "/").concat(countrySelected, "/").concat(stateSelected),
        title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/_jsx(Header, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/_jsx(SideMenu, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(getClass("background", true)),
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/_jsx(NavigationBar, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides/".concat(continentSelected, "/").concat(countrySelected));
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row flex-wrap items-center px-[20px]",
            children: (_uniqBy = uniqBy(types, "filterId")) === null || _uniqBy === void 0 ? void 0 : (_uniqBy$sort = _uniqBy.sort(function (a, b) {
              return (a === null || a === void 0 ? void 0 : a.filterOrder) - (b === null || b === void 0 ? void 0 : b.filterOrder);
            })) === null || _uniqBy$sort === void 0 ? void 0 : _uniqBy$sort.map(function (item, index) {
              var _item$filterName, _item$filterName2, _item$filterName2$rep, _item$filterName2$rep2, _item$filterName3, _item$filterName3$rep, _item$filterName4;

              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(continentSelected, "/").concat(countrySelected, "/").concat(stateSelected, "/").concat((item === null || item === void 0 ? void 0 : item.filterName) === "All" ?  false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0 : ( false ? 0 : (item === null || item === void 0 ? void 0 : item.filterName) !== "Pool" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Bar" && (item === null || item === void 0 ? void 0 : item.filterName) !== "Restaurant" ? slugify(item === null || item === void 0 ? void 0 : (_item$filterName3 = item.filterName) === null || _item$filterName3 === void 0 ? void 0 : (_item$filterName3$rep = _item$filterName3.replace(" Spa", "")) === null || _item$filterName3$rep === void 0 ? void 0 : _item$filterName3$rep.toLowerCase()) + "-" : "") + "".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0).concat(item && ((item === null || item === void 0 ? void 0 : item.filterName) === "Pool" || (item === null || item === void 0 ? void 0 : item.filterName) === "Bar" || (item === null || item === void 0 ? void 0 : item.filterName) === "Restaurant") ? "-" + slugify((item === null || item === void 0 ? void 0 : (_item$filterName4 = item.filterName) === null || _item$filterName4 === void 0 ? void 0 : _item$filterName4.toLowerCase()) + "s") : "")),
                children: /*#__PURE__*/_jsx("a", {
                  className: "flex flex-col justify-center items-center border ".concat(getClass("border-black", true), " px-[10px] py-[5px] rounded-full ").concat(getClass("text-white", true), " uppercase font-regular text-base text-center ").concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                  children: /*#__PURE__*/_jsx("div", {
                    children: item === null || item === void 0 ? void 0 : item.filterName
                  })
                }, index)
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

/* harmony default export */ var component_GuideState = ((/* unused pure expression or super */ null && (GuideState_GuideState)));
;// CONCATENATED MODULE: ./components_web/guides/GuideSpa.js


function GuideSpa_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideSpa_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideSpa_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideSpa_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideSpa = function GuideSpa(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideSpa_objectSpread(GuideSpa_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideCountry, GuideSpa_objectSpread(GuideSpa_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    if (slugs[2].includes("spas")) {
      return /*#__PURE__*/_jsx(GuideType, GuideSpa_objectSpread(GuideSpa_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideSpa_objectSpread(GuideSpa_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideSpa_objectSpread(GuideSpa_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideSpa_objectSpread(GuideSpa_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideSpa = ((/* unused pure expression or super */ null && (GuideSpa)));
;// CONCATENATED MODULE: ./components_web/guides/GuideBeachful.js


function GuideBeachful_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideBeachful_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideBeachful_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideBeachful_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideBeachful = function GuideBeachful(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideBeachful_objectSpread(GuideBeachful_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideCountry, GuideBeachful_objectSpread(GuideBeachful_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    if (slugs[2].includes("beach-clubs")) {
      return /*#__PURE__*/_jsx(GuideType, GuideBeachful_objectSpread(GuideBeachful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideBeachful_objectSpread(GuideBeachful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideBeachful_objectSpread(GuideBeachful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideBeachful_objectSpread(GuideBeachful_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideBeachful = ((/* unused pure expression or super */ null && (GuideBeachful)));
;// CONCATENATED MODULE: ./components_web/guides/GuideCocktayl.js


function GuideCocktayl_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideCocktayl_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideCocktayl_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideCocktayl_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var GuideCocktayl = function GuideCocktayl(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(component_GuideContinent/* default */.Z, GuideCocktayl_objectSpread(GuideCocktayl_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(component_GuideCountry, GuideCocktayl_objectSpread(GuideCocktayl_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(component_GuideCity, GuideCocktayl_objectSpread(GuideCocktayl_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      citySelected: slugs[2]
    }));
  } else if (slugs.length === 4) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(component_GuideType, GuideCocktayl_objectSpread(GuideCocktayl_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      citySelected: slugs[2],
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideCocktayl = (GuideCocktayl);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./components_web/guides/component/GuideYearWorld.js














var GuideYearWorld_GuideYearWorld = function GuideYearWorld(props) {
  var _showListData$sort;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();
  var listData = props.listData,
      yearSelected = props.yearSelected;

  var _useState = useState(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = useState(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = useState(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var continents = Constants.CONTINENTS;
  var showListData = listData.filter(function (i) {
    return i.region != null;
  }).map(function (item) {
    return continents.find(function (i) {
      return i.title === item.region;
    });
  });
  useEffect(function () {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(NextSeo, {
      noindex: false,
      nofollow: false,
      title: "World Guides - ".concat("Cocktayl"),
      description: "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " around the World with our guides."),
      canonical: "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected),
        title: "World Guides - ".concat("Cocktayl"),
        description: "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " around the World with our guides."),
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/_jsx(Header, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/_jsx(SideMenu, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/_jsx("div", {
      className: "bg-black",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/_jsx(NavigationBar, {
            title: "World",
            customStyle: isMobileVersion ? null : {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides");
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "grid md:grid-cols-3 grid-cols-1 sm:gap-10 gap-5 px-[20px]",
            children: showListData === null || showListData === void 0 ? void 0 : (_showListData$sort = showListData.sort(function (a, b) {
              return a.order - b.order;
            })) === null || _showListData$sort === void 0 ? void 0 : _showListData$sort.map(function (item, index) {
              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(yearSelected, "/").concat(item === null || item === void 0 ? void 0 : item.slug),
                children: /*#__PURE__*/_jsxs("a", {
                  className: "bg-grayBackground flex flex-col justify-center items-center p-[75px] rounded-2xl cursor-pointer",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "flex justify-center items-center w-[200px] h-[140px]",
                    children: /*#__PURE__*/_jsx(Image, {
                      src: item === null || item === void 0 ? void 0 : item.map,
                      width: item === null || item === void 0 ? void 0 : item.mapWidth,
                      height: item === null || item === void 0 ? void 0 : item.mapHeight,
                      alt: item === null || item === void 0 ? void 0 : item.title,
                      objectFit: "contain"
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: "flex flex-col justify-center items-center bg-grayText w-[240px] h-[50px] rounded-full text-white uppercase font-bold text-base text-center mt-[40px]",
                    children: item === null || item === void 0 ? void 0 : item.title
                  })]
                }, index)
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

/* harmony default export */ var component_GuideYearWorld = ((/* unused pure expression or super */ null && (GuideYearWorld_GuideYearWorld)));
;// CONCATENATED MODULE: ./components_web/guides/component/GuideYearContinent.js














var GuideYearContinent_GuideYearContinent = function GuideYearContinent(props) {
  var _countries$sort;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var listData = props.listData,
      yearSelected = props.yearSelected,
      continentSelected = props.continentSelected;
  var router = useRouter();

  var _useState = useState(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = useState(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = useState(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var continents = Constants.CONTINENTS;
  var countries = listData;
  var continentData = continents === null || continents === void 0 ? void 0 : continents.find(function (i) {
    return i.slug === continentSelected;
  });
  var metaTitle = "".concat(continentData === null || continentData === void 0 ? void 0 : continentData.title);
  var metaDescription = "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " in ").concat(continentData === null || continentData === void 0 ? void 0 : continentData.title, " with our guides.");
  useEffect(function () {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(NextSeo, {
      noindex: false,
      nofollow: false,
      title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected, "/").concat(continentSelected),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected, "/").concat(continentSelected),
        title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/_jsx(Header, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/_jsx(SideMenu, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/_jsx("div", {
      className: "bg-black",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/_jsx(NavigationBar, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides/".concat(yearSelected));
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row flex-wrap items-center px-[20px]",
            children: countries === null || countries === void 0 ? void 0 : (_countries$sort = countries.sort(function (a, b) {
              if (a.countryName < b.countryName) {
                return -1;
              }

              if (a.countryName > b.countryName) {
                return 1;
              }

              return 0;
            })) === null || _countries$sort === void 0 ? void 0 : _countries$sort.map(function (item, index) {
              var _item$countryName;

              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(yearSelected, "/").concat(continentSelected, "/").concat(slugify((_item$countryName = item.countryName) === null || _item$countryName === void 0 ? void 0 : _item$countryName.toLowerCase())),
                children: /*#__PURE__*/_jsx("a", {
                  className: "flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ".concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                  children: /*#__PURE__*/_jsx("div", {
                    children: item === null || item === void 0 ? void 0 : item.countryName
                  })
                }, index)
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

/* harmony default export */ var component_GuideYearContinent = ((/* unused pure expression or super */ null && (GuideYearContinent_GuideYearContinent)));
;// CONCATENATED MODULE: ./components_web/guides/component/GuideYearCountry.js















var GuideYearCountry_GuideYearCountry = function GuideYearCountry(props) {
  var _uniqBy, _uniqBy$sort, _states$sort, _cities$sort;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var listDataCountry = props.listDataCountry,
      listDataState = props.listDataState,
      listDataCity = props.listDataCity,
      listData = props.listData,
      yearSelected = props.yearSelected,
      continentSelected = props.continentSelected,
      countrySelected = props.countrySelected;
  var router = useRouter();

  var _useState = useState(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = useState(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = useState(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var countries = listDataCountry;
  var states = listDataState;
  var cities = listDataCity;
  var types = listData;
  var countryData = countries === null || countries === void 0 ? void 0 : countries.find(function (i) {
    var _i$countryName;

    return slugify((_i$countryName = i.countryName) === null || _i$countryName === void 0 ? void 0 : _i$countryName.toLowerCase()) === countrySelected;
  });
  var metaTitle = "".concat(countryData === null || countryData === void 0 ? void 0 : countryData.countryName);
  var metaDescription = "Discover ".concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " in ").concat(countryData === null || countryData === void 0 ? void 0 : countryData.countryName, " with our guides.");
  useEffect(function () {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(NextSeo, {
      noindex: false,
      nofollow: false,
      title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected),
        title: "".concat(metaTitle, " Guides - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/_jsx(Header, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/_jsx(SideMenu, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/_jsx("div", {
      className: "bg-black",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/_jsx(NavigationBar, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides/".concat(yearSelected, "/").concat(continentSelected));
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row items-center justify-center mb-[30px]",
            children: /*#__PURE__*/_jsx("div", {
              className: "flex items-center justify-center bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]",
              children: "Country"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row flex-wrap items-center px-[20px]",
            children: (_uniqBy = uniqBy(types, "filterId")) === null || _uniqBy === void 0 ? void 0 : (_uniqBy$sort = _uniqBy.sort(function (a, b) {
              return (a === null || a === void 0 ? void 0 : a.filterOrder) - (b === null || b === void 0 ? void 0 : b.filterOrder);
            })) === null || _uniqBy$sort === void 0 ? void 0 : _uniqBy$sort.map(function (item, index) {
              var _item$filterName;

              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected, "/").concat((item === null || item === void 0 ? void 0 : item.filterName) === "All" ?  false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0 : slugify(item === null || item === void 0 ? void 0 : (_item$filterName = item.filterName) === null || _item$filterName === void 0 ? void 0 : _item$filterName.toLowerCase()) + "-".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0)),
                children: /*#__PURE__*/_jsx("a", {
                  className: "flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ".concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                  children: /*#__PURE__*/_jsx("div", {
                    children: item === null || item === void 0 ? void 0 : item.filterName
                  })
                }, index)
              });
            })
          }), states.length > 0 && /*#__PURE__*/_jsx("div", {
            className: "flex flex-row items-center justify-center mb-[30px]",
            children: /*#__PURE__*/_jsx("div", {
              className: "flex items-center justify-center bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]",
              children: "State"
            })
          }), states.length > 0 && /*#__PURE__*/_jsx("div", {
            className: "flex flex-row flex-wrap items-center px-[20px]",
            children: states === null || states === void 0 ? void 0 : (_states$sort = states.sort(function (a, b) {
              if (a.stateName < b.stateName) {
                return -1;
              }

              if (a.stateName > b.stateName) {
                return 1;
              }

              return 0;
            })) === null || _states$sort === void 0 ? void 0 : _states$sort.map(function (item, index) {
              var _item$stateName;

              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected, "/").concat(slugify(item === null || item === void 0 ? void 0 : (_item$stateName = item.stateName) === null || _item$stateName === void 0 ? void 0 : _item$stateName.toLowerCase()), "-state"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ".concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                  children: /*#__PURE__*/_jsx("div", {
                    children: item === null || item === void 0 ? void 0 : item.stateName
                  })
                }, index)
              });
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row items-center justify-center mb-[30px]",
            children: /*#__PURE__*/_jsx("div", {
              className: "flex items-center justify-center bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]",
              children: "City"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row flex-wrap items-center px-[20px]",
            children: cities === null || cities === void 0 ? void 0 : (_cities$sort = cities.sort(function (a, b) {
              if (a.cityName < b.cityName) {
                return -1;
              }

              if (a.cityName > b.cityName) {
                return 1;
              }

              return 0;
            })) === null || _cities$sort === void 0 ? void 0 : _cities$sort.map(function (item, index) {
              var _item$cityName;

              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected, "/").concat(slugify(item === null || item === void 0 ? void 0 : (_item$cityName = item.cityName) === null || _item$cityName === void 0 ? void 0 : _item$cityName.toLowerCase())),
                children: /*#__PURE__*/_jsx("a", {
                  className: "flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ".concat(isMobileVersion ? "mb-[12px] mr-[12px]" : "mb-[30px] mr-[30px]"),
                  children: /*#__PURE__*/_jsx("div", {
                    children: item === null || item === void 0 ? void 0 : item.cityName
                  })
                }, index)
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

/* harmony default export */ var component_GuideYearCountry = ((/* unused pure expression or super */ null && (GuideYearCountry_GuideYearCountry)));
;// CONCATENATED MODULE: ./components_web/guides/component/GuideYearType.js





function GuideYearType_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideYearType_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideYearType_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideYearType_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var GuideYearType_GuideYearType = function GuideYearType(props) {
  var _typeData$filterName, _typeData$filterName2, _typeData$filterName3, _typeData$filterName4, _typeData$filterName5, _typeData$filterName6;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var categoryType = props.categoryType,
      listDataCountry = props.listDataCountry,
      listDataState = props.listDataState,
      listDataCity = props.listDataCity,
      listDataFilter = props.listDataFilter,
      listData = props.listData,
      countListData = props.countListData,
      yearSelected = props.yearSelected,
      continentSelected = props.continentSelected,
      countrySelected = props.countrySelected,
      stateSelected = props.stateSelected,
      citySelected = props.citySelected,
      typeSelected = props.typeSelected,
      paramsFinal = props.paramsFinal;
  var router = useRouter();

  var _useState = useState(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = useState(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = useState(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var _useState4 = useState([]),
      items = _useState4[0],
      setItems = _useState4[1];

  var _useState5 = useState(0),
      totalCount = _useState5[0],
      setTotalCount = _useState5[1];

  var _useState6 = useState(0),
      lastPageCount = _useState6[0],
      setLastPageCount = _useState6[1];

  var _useState7 = useState(0),
      pageIndex = _useState7[0],
      setPageIndex = _useState7[1];

  var _useState8 = useState(false),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var isShowLoadMore = items.length < totalCount;
  var countries = listDataCountry;
  var states = listDataState;
  var cities = listDataCity;
  var types = listDataFilter;
  var countryData = countries === null || countries === void 0 ? void 0 : countries.find(function (i) {
    var _i$countryName;

    return slugify((_i$countryName = i.countryName) === null || _i$countryName === void 0 ? void 0 : _i$countryName.toLowerCase()) === countrySelected;
  });
  var stateData = states === null || states === void 0 ? void 0 : states.find(function (i) {
    var _i$stateName;

    return slugify((_i$stateName = i.stateName) === null || _i$stateName === void 0 ? void 0 : _i$stateName.toLowerCase()) === (stateSelected === null || stateSelected === void 0 ? void 0 : stateSelected.replace("-state", ""));
  });
  var cityData = cities === null || cities === void 0 ? void 0 : cities.find(function (i) {
    var _i$cityName;

    return slugify((_i$cityName = i.cityName) === null || _i$cityName === void 0 ? void 0 : _i$cityName.toLowerCase()) === citySelected;
  });
  var typeData = types === null || types === void 0 ? void 0 : types.find(function (i) {
    var _i$filterName;

    return slugify(i === null || i === void 0 ? void 0 : (_i$filterName = i.filterName) === null || _i$filterName === void 0 ? void 0 : _i$filterName.toLowerCase()) === (typeSelected === null || typeSelected === void 0 ? void 0 : typeSelected.replace("-".concat( false ? 0 :  false ? 0 :  true ? "cocktail-bars" : 0), ""));
  });
  var metaTitle = "".concat(typeData && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Pool" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Bar" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Restaurant" ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName = typeData.filterName) === null || _typeData$filterName === void 0 ? void 0 : _typeData$filterName.replace("All", "")) + " " : "").concat( false ? 0 :  false ? 0 :  true ? "Cocktail Bars" : 0, " ").concat(typeData && ((typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Pool" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Bar" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Restaurant") ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName2 = typeData.filterName) === null || _typeData$filterName2 === void 0 ? void 0 : _typeData$filterName2.replace("All", "")) + "s " : "").concat((cityData === null || cityData === void 0 ? void 0 : cityData.cityName) || (stateData === null || stateData === void 0 ? void 0 : stateData.stateName) || (countryData === null || countryData === void 0 ? void 0 : countryData.countryName)).concat(yearSelected ? " ".concat(yearSelected) : "");
  var metaDescription = "Discover all the ".concat(typeData && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Pool" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Bar" && (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) !== "Restaurant" ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName3 = typeData.filterName) === null || _typeData$filterName3 === void 0 ? void 0 : (_typeData$filterName4 = _typeData$filterName3.replace("All", "")) === null || _typeData$filterName4 === void 0 ? void 0 : _typeData$filterName4.toLowerCase()) + " " : "").concat( false ? 0 :  false ? 0 :  true ? "cocktail bars" : 0, " ").concat(typeData && ((typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Pool" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Bar" || (typeData === null || typeData === void 0 ? void 0 : typeData.filterName) === "Restaurant") ? (typeData === null || typeData === void 0 ? void 0 : (_typeData$filterName5 = typeData.filterName) === null || _typeData$filterName5 === void 0 ? void 0 : (_typeData$filterName6 = _typeData$filterName5.replace("All", "")) === null || _typeData$filterName6 === void 0 ? void 0 : _typeData$filterName6.toLowerCase()) + "s " : "", "in ").concat((cityData === null || cityData === void 0 ? void 0 : cityData.cityName) || (stateData === null || stateData === void 0 ? void 0 : stateData.stateName) || (countryData === null || countryData === void 0 ? void 0 : countryData.countryName), " in ").concat(yearSelected, " with our guide.");
  var updatedAt = moment().startOf("week").add("2", "days").toISOString();
  var canonicalURL = "https://".concat("www.cocktayl.co", "/guides/").concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected, "/").concat(typeSelected);
  useEffect(function () {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  var onLoad = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var page,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;

              if (!isLoading) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setIsLoading(true);
              FestivalDao.findWeb(GuideYearType_objectSpread(GuideYearType_objectSpread({}, paramsFinal), {}, {
                pageSize: 100,
                pageIndex: page
              })).then(function (result) {
                if (page == 0) {
                  setItems(result.data);
                } else {
                  setItems([].concat(_toConsumableArray(items), _toConsumableArray(result.data)));
                }

                setLastPageCount(result.data.length);
                setTotalCount(result.totalCount);
                setIsLoading(false);
              })["catch"](function (error) {
                setIsLoading(false);
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onLoad() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    onLoad();
  }, []);

  var onLoadMore = function onLoadMore() {
    if (lastPageCount == 100 && !isLoading) {
      setPageIndex(pageIndex + 1);
      onLoad(pageIndex + 1);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": canonicalURL,
            url: canonicalURL,
            name: metaTitle,
            dateModified: updatedAt
          })
        }
      }, "structured-data")
    }), /*#__PURE__*/_jsx(NextSeo, {
      title: "".concat(metaTitle, " - ").concat("Cocktayl"),
      description: metaDescription,
      canonical: canonicalURL,
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: canonicalURL,
        title: "".concat(metaTitle, " - ").concat("Cocktayl"),
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/_jsx(Header, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/_jsx(SideMenu, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/_jsx("div", {
      className: "bg-black",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/_jsx(NavigationBar, {
            title: metaTitle,
            customStyle: {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              return router.push("/guides/".concat(yearSelected, "/").concat(continentSelected, "/").concat(countrySelected));
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-row justify-center items-center",
            children: /*#__PURE__*/_jsx("div", {
              className: "flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white font-regular sm:text-base text-xs text-center mb-[30px]",
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "text-grayText2",
                  children: countListData
                }), "\xA0", categoryType === Constants.categoryType.CATEGORY_VENUE || categoryType === Constants.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bars" : categoryType === Constants.categoryType.CATEGORY_ROOFTOP ? "Rooftops" : categoryType === Constants.categoryType.CATEGORY_SPA ? "Spas" : categoryType === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Clubs" : categoryType === Constants.categoryType.CATEGORY_PREFAB_COMPANY ? "Companies" : categoryType === Constants.categoryType.CATEGORY_PARKFUL ? "Amusement Parks" : categoryType === Constants.categoryType.CATEGORY_CASINO ? "Casinos" : categoryType === Constants.categoryType.CATEGORY_RESORT ? "Resorts" : categoryType === Constants.categoryType.CATEGORY_APARTHOTEL ? "Aparthotels" : categoryType === Constants.categoryType.CATEGORY_FESTIVAL ? "Festivals" : "Venues"]
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CardList, {
              isChartsMode: false,
              isGuides: true,
              horizontal: false,
              gridView: false,
              items: items.length > 0 ? items : listData,
              category: categoryType,
              style: {
                marginTop: 16
              } // onItemAction={({ type, item }) => onItemAction({ type, item })}
              ,
              isLoadingNextPage: false,
              isLoading: false,
              isExploreSearch: true,
              isMobileVersion: isMobileVersion,
              gapHeight: 0
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-row items-center justify-center",
            children: [isShowLoadMore && !isLoading && /*#__PURE__*/_jsx(TouchableOpacity, {
              style: isMobileVersion ? GuideYearType_styles.mobileLoadMoreButtonContainer : GuideYearType_styles.loadMoreButtonContainer,
              onPress: onLoadMore,
              children: /*#__PURE__*/_jsx(Text, {
                style: [GuideYearType_styles.buttonText, isMobileVersion && {
                  fontSize: 12,
                  lineHeight: 12
                }],
                children: "VIEW MORE"
              })
            }), isShowLoadMore && isLoading && /*#__PURE__*/_jsx("div", {
              className: "mt-[20px]",
              children: /*#__PURE__*/_jsx(ActivityIndicator, {})
            })]
          }), listData.length > 0 && /*#__PURE__*/_jsx(LastUpdate, {
            isMobileVersion: isMobileVersion,
            updatedAt: updatedAt,
            isGuide: true
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

var GuideYearType_styles = StyleSheet_default().create({
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18
  },
  buttonText: {
    color: config/* Colors.white */.wL.white,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    textAlign: "center"
  }
});
/* harmony default export */ var component_GuideYearType = ((/* unused pure expression or super */ null && (GuideYearType_GuideYearType)));
;// CONCATENATED MODULE: ./components_web/guides/GuideFestyful.js


function GuideFestyful_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideFestyful_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideFestyful_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideFestyful_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var GuideFestyful = function GuideFestyful(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideYearWorld, GuideFestyful_objectSpread(GuideFestyful_objectSpread({}, props), {}, {
      yearSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideYearContinent, GuideFestyful_objectSpread(GuideFestyful_objectSpread({}, props), {}, {
      yearSelected: slugs[0],
      continentSelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    return /*#__PURE__*/_jsx(GuideYearCountry, GuideFestyful_objectSpread(GuideFestyful_objectSpread({}, props), {}, {
      yearSelected: slugs[0],
      continentSelected: slugs[1],
      countrySelected: slugs[2]
    }));
  } else if (slugs.length === 4) {
    return /*#__PURE__*/_jsx(GuideYearType, GuideFestyful_objectSpread(GuideFestyful_objectSpread({}, props), {}, {
      yearSelected: slugs[0],
      continentSelected: slugs[1],
      countrySelected: slugs[2],
      stateSelected: slugs[3],
      citySelected: slugs[3],
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideFestyful = ((/* unused pure expression or super */ null && (GuideFestyful)));
;// CONCATENATED MODULE: ./components_web/guides/GuideVybeful.js


function GuideVybeful_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideVybeful_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideVybeful_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideVybeful_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var GuideVybeful = function GuideVybeful(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideVybeful_objectSpread(GuideVybeful_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideCountry, GuideVybeful_objectSpread(GuideVybeful_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    return /*#__PURE__*/_jsx(GuideCity, GuideVybeful_objectSpread(GuideVybeful_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      citySelected: slugs[2]
    }));
  } else if (slugs.length === 4) {
    return /*#__PURE__*/_jsx(GuideType, GuideVybeful_objectSpread(GuideVybeful_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      citySelected: slugs[2],
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideVybeful = ((/* unused pure expression or super */ null && (GuideVybeful)));
;// CONCATENATED MODULE: ./components_web/guides/GuidePrefab.js


function GuidePrefab_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuidePrefab_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuidePrefab_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuidePrefab_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var GuidePrefab = function GuidePrefab(props) {
  var slugs = props.slugs;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideCountry, GuidePrefab_objectSpread(GuidePrefab_objectSpread({}, props), {}, {
      continentSelected: null,
      countrySelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideType, GuidePrefab_objectSpread(GuidePrefab_objectSpread({}, props), {}, {
      continentSelected: null,
      countrySelected: slugs[0],
      stateSelected: slugs[1].includes("-state") && !slugs[1].includes("prefab-homes-manufacturers") ? slugs[1] : null,
      citySelected: null,
      typeSelected: slugs[1].includes("prefab-homes-manufacturers") && !slugs[1].includes("-state") ? slugs[1] : null
    }));
  }
};

/* harmony default export */ var guides_GuidePrefab = ((/* unused pure expression or super */ null && (GuidePrefab)));
;// CONCATENATED MODULE: ./components_web/guides/GuideZoo.js


function GuideZoo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideZoo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideZoo_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideZoo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideZoo = function GuideZoo(props) {
  var slugs = props.slugs,
      paramsFinal = props.paramsFinal;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    if (!slugs[1].includes("-city") && !slugs[1].includes("-state") && slugs[0] == "world") {
      return /*#__PURE__*/_jsx(GuideType, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        typeSelected: slugs[1]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCountry, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1]
      }));
    }
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideType, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideZoo_objectSpread(GuideZoo_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideZoo = ((/* unused pure expression or super */ null && (GuideZoo)));
;// CONCATENATED MODULE: ./components_web/guides/GuideParkful.js


function GuideParkful_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideParkful_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideParkful_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideParkful_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideParkful = function GuideParkful(props) {
  var slugs = props.slugs,
      paramsFinal = props.paramsFinal;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    if (!slugs[1].includes("-city") && !slugs[1].includes("-state") && slugs[0] == "world") {
      return /*#__PURE__*/_jsx(GuideType, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        typeSelected: slugs[1]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCountry, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1]
      }));
    }
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideType, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideParkful_objectSpread(GuideParkful_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideParkful = ((/* unused pure expression or super */ null && (GuideParkful)));
;// CONCATENATED MODULE: ./components_web/guides/GuideCasino.js


function GuideCasino_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideCasino_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideCasino_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideCasino_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideCasino = function GuideCasino(props) {
  var slugs = props.slugs,
      paramsFinal = props.paramsFinal;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    if (!slugs[1].includes("-city") && !slugs[1].includes("-state") && slugs[0] == "world") {
      return /*#__PURE__*/_jsx(GuideType, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        typeSelected: slugs[1]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCountry, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1]
      }));
    }
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideType, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideCasino_objectSpread(GuideCasino_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideCasino = ((/* unused pure expression or super */ null && (GuideCasino)));
;// CONCATENATED MODULE: ./components_web/guides/GuideCastle.js


function GuideCastle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideCastle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideCastle_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideCastle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideCastle = function GuideCastle(props) {
  var slugs = props.slugs,
      paramsFinal = props.paramsFinal;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideCastle_objectSpread(GuideCastle_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideCountry, GuideCastle_objectSpread(GuideCastle_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideType, GuideCastle_objectSpread(GuideCastle_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideCastle_objectSpread(GuideCastle_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideCastle_objectSpread(GuideCastle_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideCastle_objectSpread(GuideCastle_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideCastle = ((/* unused pure expression or super */ null && (GuideCastle)));
;// CONCATENATED MODULE: ./components_web/guides/GuideResort.js


function GuideResort_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideResort_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideResort_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideResort_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideResort = function GuideResort(props) {
  var slugs = props.slugs,
      paramsFinal = props.paramsFinal;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    if (!slugs[1].includes("-city") && !slugs[1].includes("-state") && slugs[0] == "world") {
      return /*#__PURE__*/_jsx(GuideType, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        typeSelected: slugs[1]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCountry, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1]
      }));
    }
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideType, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideResort_objectSpread(GuideResort_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideResort = ((/* unused pure expression or super */ null && (GuideResort)));
;// CONCATENATED MODULE: ./components_web/guides/GuideAparthotel.js


function GuideAparthotel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GuideAparthotel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GuideAparthotel_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GuideAparthotel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var GuideAparthotel = function GuideAparthotel(props) {
  var slugs = props.slugs,
      paramsFinal = props.paramsFinal;

  if (slugs.length === 1) {
    return /*#__PURE__*/_jsx(GuideContinent, GuideAparthotel_objectSpread(GuideAparthotel_objectSpread({}, props), {}, {
      continentSelected: slugs[0]
    }));
  } else if (slugs.length === 2) {
    return /*#__PURE__*/_jsx(GuideCountry, GuideAparthotel_objectSpread(GuideAparthotel_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1]
    }));
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideType, GuideAparthotel_objectSpread(GuideAparthotel_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        typeSelected: slugs[2]
      }));
    } else if (slugs[2].includes("-state")) {
      return /*#__PURE__*/_jsx(GuideState, GuideAparthotel_objectSpread(GuideAparthotel_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        stateSelected: slugs[2]
      }));
    } else {
      return /*#__PURE__*/_jsx(GuideCity, GuideAparthotel_objectSpread(GuideAparthotel_objectSpread({}, props), {}, {
        continentSelected: slugs[0],
        countrySelected: slugs[1],
        citySelected: slugs[2]
      }));
    }
  } else if (slugs.length === 4) {
    var _slugs$, _slugs$2;

    return /*#__PURE__*/_jsx(GuideType, GuideAparthotel_objectSpread(GuideAparthotel_objectSpread({}, props), {}, {
      continentSelected: slugs[0],
      countrySelected: slugs[1],
      stateSelected: (_slugs$ = slugs[2]) !== null && _slugs$ !== void 0 && _slugs$.includes("-state") ? slugs[2] : null,
      citySelected: !((_slugs$2 = slugs[2]) !== null && _slugs$2 !== void 0 && _slugs$2.includes("-state")) ? slugs[2] : null,
      typeSelected: slugs[3]
    }));
  }
};

/* harmony default export */ var guides_GuideAparthotel = ((/* unused pure expression or super */ null && (GuideAparthotel)));
;// CONCATENATED MODULE: ./pages/guides/[...slugs].js


function _slugs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _slugs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _slugs_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _slugs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var GuideSlug = function GuideSlug(props) {
  if (false) {} else if (false) {} else if (true) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(guides_GuideCocktayl, _slugs_objectSpread({}, props));
  } else {}
};

var __N_SSP = true;
/* harmony default export */ var _slugs_ = (GuideSlug);

/***/ }),

/***/ 55752:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[...slugs]",
      function () {
        return __webpack_require__(20661);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1664,2427,9319,2738,2460,793,3732,6497,9774,2888,179], function() { return __webpack_exec__(55752); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);